export default "__VITE_ASSET__3e01408f__"